import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import '@et/ui/styles.css';
import './styles.css';
import { createQueryClient } from './app/providers.js';
import { createRouter } from './app/router.js';
import { startAnalytics } from './lib/analytics.js';
import { firebaseConfigFromEnv } from './lib/auth.js';
import { readConsent } from './lib/consent.js';

const client = createQueryClient();
const root = document.getElementById('root');
if (root === null) throw new Error('#root em falta');

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={createRouter(client)} />
  </StrictMode>,
);

// **So depois de um sim.** Sem esta linha o banner era decoracao: o modulo
// carregava, o gtag descarregava e o cookie ficava posto antes de alguem ter
// respondido, que e exactamente o que a pergunta existe para impedir. O
// estado por omissao — ninguem respondeu — nao mede nada.
//
// Depois do `render` e sem `await`: o arquivo nao espera pela medicao para
// aparecer. `void` porque a promessa nunca rejeita — ver `analytics.ts`.
if (readConsent() === 'granted') {
  void startAnalytics({ config: firebaseConfigFromEnv() });
}
